import axios from 'axios';
import RouteUrls from '../common/RouteUrls';

export const credentialRecoveryEmail = async (emailId) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.CREDENTIAL_RECOVERY_ENDPOINT,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'device-id':
        '12345'
      },
      data: {
        email: emailId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching Email : ', error);
    throw error;
  }
};